<template>
	<div>
		<div class="mengCeng">
			<img src="@/assets/images/mencheng.png" class="w-100 mengCengtu" alt="">
		</div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>公司详情</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row">
		            <div class="col-lg-5 col-md-6">
		                <h3 style="margin-bottom: 20px;color: #4A4A4A;">{{merchantInfo.name}}</h3>
						<p style="margin-bottom: 20px;color: #666666;">公司热线:{{merchantInfo.phone}}</p>
						<p style="margin-bottom: 20px;color: #666666;">企业地址:{{merchantInfo.address}}{{merchantInfo.detailed_address}}</p>
						<div class="icon-box">
							<Tooltip v-if="merchantInfo.website" content="点击查看官网" placement="top" theme="light">
							    <a class="mr-2" :href="merchantInfo.website" target="_blank"><img src="@/assets/images/we.png" alt="" style="width: 50px;height: 50px;"></a>
							</Tooltip>
							<Tooltip v-if="merchantInfo.store_type == 1" content="点击前往京东" placement="top" theme="light">
							    <a class="mr-2" :href="merchantInfo.store_url" target="_blank"><img src="@/assets/images/jd.png" alt="" style="width: 50px;height: 50px;"></a>
							</Tooltip>
							<Tooltip v-if="merchantInfo.store_type == 2" content="点击前往淘宝" placement="top" theme="light">
							    <a class="mr-2" :href="merchantInfo.store_url" target="_blank"><img src="@/assets/images/tb.png" alt="" style="width: 50px;height: 50px;"></a>
							</Tooltip>
							<Tooltip v-if="merchantInfo.wechat_public" content="点击前往淘宝" placement="top" theme="light">
								<img src="@/assets/images/wx.png" alt="" style="width: 50px;height: 50px;">
								<template #content>
								   <span>微信关注公众号{{merchantInfo.wechat_public}}</span>
								</template>
							</Tooltip>
						</div>
		            </div>
		            <div class="col-lg-7 col-md-6" v-if="merchantInfo.oblong_image">
						<Carousel :autoplay="merchantInfo.oblong_image.length>1?true:false" loop :autoplay-speed="3000">
							<CarouselItem v-for="(item,index) in merchantInfo.oblong_image" :key="index">
								<div class="demo-carousel">
									<img :src="item | imgfilter" >
								</div>
							</CarouselItem>
						</Carousel>
		            </div>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
		            <button v-for="(cate,index) in cateList" :class="cateIndex==cate.id?'active':''" :key="cate.id" class="btn-project" style="margin: 0 50px;" @click="clickCate(cate.id)">{{cate.name}}</button>
		        </div>
		        <div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid">
		            <div class="col mb-6 grid-item cat2 cat4" v-for="(item,index) in dataList" :key="item.id">
		                <div class="project-wrap">
		                    <div class="project-inner">
								<a @click="toDetail(item.id)" class="thumbnail">
									<img src="" alt="">
								    <img :src="item.image || item.main_pic | imgfilter" alt="Blog Image" style="height: 370px;object-fit: cover;">
								</a>
		                        <div class="project-content d-flex">
									<div style="flex: 1;">
										<div>
											<a @click="toDetail(item.id)" class="thumbnail">
												{{item.name || item.title}}
											</a>
											
										</div>
										<span class="tag" v-for="(ta,ti) in item.tags" :key="ti">{{ta}}</span>
									</div>
									<div class="collent" v-if="cateIndex!=(2|3)">
										<Icon v-if="item.isLike" style="cursor: pointer;" size="30" type="ios-heart" color="#ff495e" @click="collect(item)" />
										<Icon v-else size="30" style="cursor: pointer;" type="ios-heart-outline" @click="collect(item)" />
										<div>{{item.like_count}}</div>
									</div>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		<div class="inapp">
			<span @click="getHref">在APP中打开</span>
		</div>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
import { 
	getMerPromList,
	getMerchantInfo,
	getMerchantProductList,
	getMerchantProjectList,
	getMerchantShowList,
	LikeAdd,
	LikeDel,
	ShowLikeAdd,
	ShowLikeDel,
	merchantView
} from '@/api'
export default {
   name: 'app',
   data() {
		return { 
			nameInfo: '',
			merchantInfo: {},
			bgImg: require('@/static/images/banner/banner-3.jpg'),
			
			cateList: [
				{
					id: 0,
					name: '案例',
				},
				{
					id: 1,
					name: '展厅',
				},
				{
					id: 2,
					name: '产品'
				},
				{
					id: 3,
					name: '活动'
				},
			],
			
			dataList: [],
			cateIndex: 0,
			
			total: 0,
			currentPage: 1,
		}
	},
	created() {
		this.getMerchantInfo()
		this.getMerchantProjectList()
		this.getmerchantView()
	},
	computed: {
		isLogin() {
		  return getCookies("webtoken");
		},
	},
	methods:{
		
		getHref() {
			let that = this
			var ua = navigator.userAgent.toLowerCase();
			var isWeixin = ua.indexOf('micromessenger') != -1;
			let mengCeng = document.querySelector('.mengCeng');
			let mengCengtu = document.querySelector('.mengCengtu');
			if (isWeixin) {
				mengCeng.style.height = "100vh";
				mengCengtu.style.display = "block";
			    return;
			}
			let params = 'pid='+ this.$route.params.id + '&type='+3
			that.opening = true
			//android终端
			let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
			//ios终端
			let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				console.log('ios')
				window.location = "zhuke://" + params
				that.timer = setTimeout(function () { //  未安装的情况
					that.opening = false
					//  跳转app store
					let r = confirm("未安装APP? 是否去App store查看")
					if (r) {
						window.location = 'https://apps.apple.com/cn/app/筑壳/id1624314273'
					}
			    }, 3000);
				mengCeng.style.height = "0vh";
				mengCengtu.style.display = "none";
			} else {
				let ifr = document.createElement('iframe');
				ifr.src ="zhuke://" + params;
				ifr.style.display = 'none';
				document.body.appendChild(ifr);
				that.timer = window.setTimeout(function () {  //  未安装的情况
					that.opening = false
					document.body.removeChild(ifr);
					//  提示下载
					let r = confirm("未安装APP? 是否下载")
					if (r) {
						window.location = 'https://www.zikkkk.com/downloadApp/筑壳.apk'
					}
				}, 3000)
				mengCeng.style.height = "0vh";
				mengCengtu.style.display = "none";
			}
		},
		
		clickCate(id) {
			this.cateIndex = id
			switch (id){
				case 1:
					this.getMerchantShowList()
					break;
				case 2:
					this.getMerchantProductList()
					break;	
				case 3:
					this.getPromoList()
					break;
				default:
					this.getMerchantProjectList()
					break;
			}
		},
		
		toDetail(id) {
			switch (this.cateIndex){
				case 0:
					this.$router.push({path:'/projectDetail/'+ id })
					break;
				case 1:
					this.$router.push({path:'/showDetail/'+ id })
					break;
				case 2:
					this.$router.push({path:'/productDetail/'+ id })
					break;	
				case 3:
					this.$router.push({path: '/promotionDetail/' + id})
					break;	
				default:
					break;
			}
		},
		// 获取活动数据
		async getPromoList() {
			const res = await getMerPromList({id: this.merchantInfo.id}).then(res => {
				this.dataList = res.data
				this.dataList.forEach(item => {
					item.tags = item.tags.split(',')
				})
			})
		},

		// 获取商家详情
		async getmerchantView() {
		  const res = await merchantView({
			  type: 3
		  })
		},
		
		// 获取商家详情
		async getMerchantInfo() {
		  const res = await getMerchantInfo({
			  zk_id: this.$route.params.id
		  })
		  let data = res.data
		  this.merchantInfo = data.info
		},
		
		// 获取案例分类列表
		async getMerchantProjectList() {
		  const res = await getMerchantProjectList({
			  publish_id: this.$route.params.id,
			  page: this.currentPage,
			  limit: 50
		  })
		  let data = res.data
		  data.forEach(e => {
		  	if(e.tags) e.tags = e.tags.split(',') || []
		  })
		  this.dataList = data
		},
		
		// 获取展厅分类列表
		async getMerchantShowList() {
		  const res = await getMerchantShowList({
			  zk_id: this.$route.params.id,
			  page: this.currentPage,
			  limit: 50
		  })
		  let data = res.data
		  data.forEach(e => {
		  	if(e.tags) e.tags = e.tags.split(',') || []
		  })
		  this.dataList = data
		},
		
		// 获取产品分类列表
		async getMerchantProductList() {
		  const res = await getMerchantProductList({
			  zk_id: this.$route.params.id,
			  page: this.currentPage,
			  limit: 50
		  })
		  let data = res.data
		  data.forEach(e => {
		  	if(e.tags) e.tags = e.tags.split(',') || []
		  })
		  this.dataList = data
		},
		
		collect(item){
			if(!this.isLogin) {
				alert('请登录后操作')
				return false
			}
			if(item.isLike == 0){
				if(this.cateIndex == 1) {
					ShowLikeAdd({
						show_id: item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 1
							item.like_count++
						}
					})
				} else {
					LikeAdd({
						pro_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 1
							item.like_count++
						}
					})
				}
			}else{
				if(this.cateIndex == 1) {
					ShowLikeDel({
						show_id: item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 0
							item.like_count--
						}
					})
				} else {
					LikeDel({
						pro_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 0
							item.like_count--
						}
					})
				}
			}
		},
		
	}
}
</script>

<style>
	.mengCengtu {
		display: none;
	}
	
	.w-100 {
		width: 100%;
	}
	
	body {
		position: relative;
	}
	
	/* 蒙层 */
	.mengCeng {
		position: fixed;
		top: 0;
		left: 0;
		opacity: 0.8;
		width: 100vw;
		height: 0vh;
		z-index: 999;
		background-color: #323232;
	}
	
	.icon-box {
		margin-left: 20px;
	}
</style>
